module.exports = __webpack_public_path__ + "img/375.60acec4f.jpg";